module.exports = __webpack_public_path__ + "img/20200106155643435.8380d0bc.jpg";